import { render } from "./milestone-carousel-description.vue?vue&type=template&id=6fcf7cd5&scoped=true&ts=true"
import script from "./milestone-carousel-description.vue?vue&type=script&lang=ts"
export * from "./milestone-carousel-description.vue?vue&type=script&lang=ts"

import "./milestone-carousel-description.vue?vue&type=style&index=0&id=6fcf7cd5&lang=scss&scoped=true"
import "./milestone-carousel-description.vue?vue&type=style&index=1&id=6fcf7cd5&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcf7cd5"]])

export default __exports__